// extracted by mini-css-extract-plugin
export default {"playerName":"PlayerInfo_playerName__wArv5","playerAttributes":"PlayerInfo_playerAttributes__Bjo1J"};